export const breakpoints = {
  xsMinWidth: '500px',
  xmMinWidth: '768px',
  xmMaxWidth: '1151px',
} as const

export const webBreakpoints = {
  maxMobileWidth: '767px',
  maxTabletWidth: '1279px',
} as const
